import React, { useState } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, Box, CircularProgress } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Divider from '@mui/material/Divider';
import dayjs, { Dayjs } from 'dayjs';

import { PostOnboardDeviceLogsRequest } from '../../interfaces';

interface Props {
    uploadInProgress: boolean;
    onSync: (payload: PostOnboardDeviceLogsRequest) => void;
}

export const SyncLogsForm = ({ uploadInProgress, onSync }: Props) => {
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().subtract(7, 'day'));
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [allLogs, setAllLogs] = useState(false);

    const handleSync = () => {
        const payload = allLogs
            ? {
                  startDate: null,
                  endDate: null,
              }
            : {
                  startDate: startDate?.format('YYYY-MM-DD'),
                  endDate: endDate?.format('YYYY-MM-DD'),
              };

        onSync(payload);
    };

    return (
        <Box display="flex" gap={2} alignItems="center" my={2} flexWrap="wrap">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                    label="Start Date"
                    value={startDate}
                    inputFormat="DD.MM.YYYY"
                    onChange={(newValue) => setStartDate(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    disabled={allLogs}
                />
                <DesktopDatePicker
                    label="End Date"
                    value={endDate}
                    inputFormat="DD.MM.YYYY"
                    onChange={(newValue) => setEndDate(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    disabled={allLogs}
                />
            </LocalizationProvider>
            <Divider orientation="vertical" flexItem>
                <p>or</p>
            </Divider>
            <FormControlLabel
                control={<Checkbox checked={allLogs} onChange={(e) => setAllLogs(e.target.checked)} />}
                label="All new logs"
            />
            <Button variant="contained" onClick={handleSync} disabled={uploadInProgress}>
                Sync
                {uploadInProgress && <CircularProgress style={{ marginLeft: '5px' }} size={15} />}
            </Button>
        </Box>
    );
};
